import { CFOccurrence } from '@scentregroup/shared/types/contentful'

import { CentreTime } from '../use-centre-time'
import { formatTimeAMPM, formatDayAndMonth } from '../date-format-helpers'

export type EventContentDetail = {
  title?: string
  description?: string
  address?: string
  startAt?: string
  endAt?: string
  hideAt?: string
  occurrences: Pick<CFOccurrence, 'startAt' | 'endAt'>[]
}

const getPastOcc = (
  occ: Pick<CFOccurrence, 'startAt' | 'endAt'>,
  centreTime: CentreTime | null
): string => {
  if (centreTime) {
    const { startAt: centreStart, endAt: centreEnd } =
      centreTime.fromEntryISO(occ)
    return `${centreTime.formatHumanDay(centreStart)} ${formatDayAndMonth(
      centreStart
    )}, ${formatTimeAMPM(centreStart)} - ${formatTimeAMPM(centreEnd)}`
  }
  return ''
}

export const getEventOccurrences = (
  occurrences: Pick<CFOccurrence, 'startAt' | 'endAt'>[],
  centreTime: CentreTime | null
): string[] => {
  return occurrences
    .map(occ => ({
      content: getPastOcc(occ, centreTime),
    }))
    .flatMap(item => item.content || [])
}
